import { cn } from '@/lib/utils'
import { VOICE_LABELS } from '@/lib/voice'
import type { VoiceSlot } from '@/lib/types'

/** Small pill marking which backbone slot an exercise belongs to. */
export default function VoiceBadge({ voice, className }: { voice: VoiceSlot; className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border border-golden bg-secondary px-2 py-0.5 text-xs font-medium text-secondary-foreground',
        className
      )}
    >
      {VOICE_LABELS[voice] ?? voice}
    </span>
  )
}
